import {createSlice} from "@reduxjs/toolkit";
import {IScheduleAppointment} from "../../interfaces";

export const reducerName = "scheduling";
export const initialState:IScheduleAppointment = {
    reasonType: "ADVICE&TRIAGE",
    serviceType: "ADVICE_CHAT",
    immediate: false,
    selectedPetId: 0,
    isGiftReceived: false,
    state: "",
    vetId: 0,
    vetProfileId: 0,
    vetProfile: {},
    price: "",
    additionalInfo: "",
    paymentMethod: "WITHOUT_CREDITS",
    pickedDate: "",
    pickedTimeSlot: [],
    uploadPhotos: {},
    uploadVideo: null,
    phone: "",
    chatId: "",
    promo: "",
    pdf: "",
    funnelEmailGiftId: null,
};

const schedulingReducer = createSlice({
    name: reducerName,
    initialState,
    reducers: {
        setServiceType: (state, action) => ({
            ...state,
            serviceType: action.payload
        }),
        setIsGiftReceived: (state, action) => ({
            ...state,
            isGiftReceived: action.payload
        }),
        setPaymentMethod: (state, action) => ({
            ...state,
            paymentMethod: action.payload
        }),
        setIsImmediate: (state, action) => ({
            ...state,
            immediate: action.payload as boolean
        }),
        setSelectedState: (state, action) => ({
            ...state,
            state: action.payload
        }),
        setVetProfileId: (state, action) => ({
            ...state,
            vetProfileId: action.payload
        }),
        setRequestReason: (state, action) => ({
            ...state,
            reasonType: action.payload
        }),
        setVetProfile: (state, action) => ({
            ...state,
            vetProfile: action.payload
        }),
        setPickedDate: (state, action) => ({
            ...state,
            pickedDate: action.payload
        }),
        setSelectedPetID: (state, action) => ({
            ...state,
            selectedPetId: action.payload
        }),
        setAdditionalInfo: (state, action) => ({
            ...state,
            additionalInfo: action.payload
        }),
        setVetId: (state, action) => ({
            ...state,
            vetId: action.payload
        }),
        setPromotionCode: (state, action) => ({
            ...state,
            promo: action.payload
        }),
        setPrice: (state, action) => ({
            ...state,
            price: action.payload
        }),
        setPickedTimeSlot: (state, action) => ({
            ...state,
            pickedTimeSlot: action.payload
        }),
        setPhotos: (state, action) => ({
            ...state,
            uploadPhotos: {
                ...state.uploadPhotos,
                [action.payload.idx]: action.payload.photo
            }
        }),
        deletePhotos: (state) => ({
            ...state,
            uploadPhotos: {}
        }),
        deletePhoto: (state, action) => {
            delete state.uploadPhotos[action.payload];
        },
        setVideo: (state, action) => ({
            ...state,
            uploadVideo: action.payload,
        }),
        deleteVideo: (state) => ({
            ...state,
            uploadVideo: null,
        }),
        setPDF: (state, action) => ({
            ...state,
            pdf: action.payload
        }),
        setFunnelEmailGiftId: (state, action) => ({
            ...state,
            funnelEmailGiftId: action.payload
        }),
        clearAppointmentInfo: () => initialState,
    }
});

export default schedulingReducer.reducer;
export const {
    setServiceType,
    setPaymentMethod,
    setIsImmediate,
    setSelectedState,
    setVetProfileId,
    setRequestReason,
    setVetProfile,
    setPickedDate,
    setSelectedPetID,
    setAdditionalInfo,
    setVetId,
    setPromotionCode,
    setPrice,
    setPickedTimeSlot,
    setPhotos,
    setVideo,
    setIsGiftReceived,
    setPDF,
    clearAppointmentInfo,
    setFunnelEmailGiftId,
    deletePhotos,
    deletePhoto,
    deleteVideo,
} = schedulingReducer.actions;
